import { render, staticRenderFns } from "./VuewerBase.vue?vue&type=template&id=2bc9ad4d&"
import script from "./VuewerBase.vue?vue&type=script&lang=js&"
export * from "./VuewerBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports